import React from 'react';
import { AlertTriangleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const baseFeatures = ['5 Tomos PDF completos (Hombro, Rodilla, Tobillo, Codo y Muñeca, Columna y Cadera)', 'Método Progresión Blindada en las 5 articulaciones', '5 Bonos estratégicos gratis', 'Acceso inmediato', 'Garantía de 7 días'];
const premiumFeatures = ['TODO el Combo Completo Rehabilitación de Lesiones', 'Catálogo completo de ejercicios en 3 niveles: principiante, intermedio y avanzado', 'Plan práctico de 8 semanas con calendario de entrenamiento', 'Progresión de cargas con el Sistema Semáforo', 'Protocolo de retorno al deporte específico: fútbol, running, CrossFit, tenis', 'Planilla de seguimiento de 8 semanas lista para imprimir'];
function PlanCard({
  premium = false
}: {
  premium?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'Paquete Combinado Rehabilitación + Programa de Retorno al Entrenamiento' : 'Combo Completo Rehabilitación de Lesiones';
  const subtitle = premium ? '5 Tomos + 5 Bonos + Programa Premium de Retorno' : '5 Tomos + 5 Bonos';
  const price = premium ? '$27.990' : '$19.990';
  const before = premium ? '$75.000' : '$60.000';
  const savings = premium ? '$47.000' : '$40.000';
  return <article className={`relative flex flex-col rounded-3xl p-6 md:p-8 ${premium ? 'border-4 border-gold bg-primary text-white shadow-[0_25px_60px_rgba(3,105,161,.35)] ring-4 ring-gold/30 md:scale-[1.025]' : 'border border-sky-100 bg-white shadow-sm'}`} data-id="element-264" data-mp="2yl5j0d56xw7x">
      {premium && <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full border-2 border-amber-200 bg-gold px-4 py-1.5 text-xs font-extrabold text-white shadow-lg" data-id="element-265" data-mp="33dykms5d4ofs">
          <StarIcon className="h-4 w-4 fill-current" data-id="element-266" data-mp="3cc0i4xpw0yyb" /> MÁS ELEGIDO
        </div>}
      <div className={premium ? 'mt-2' : ''} data-id="element-267" data-mp="29yceqkp2ihf4">
        <div className="flex items-start gap-2" data-id="element-268" data-mp="2ez0d5rfmm0jd">
          <span className="text-3xl" data-id="element-269" data-mp="2ezs42oya3a3b">{premium ? '💎' : '📚'}</span>
          <h3 className={`text-xl font-extrabold leading-tight ${premium ? 'text-white' : 'text-slate-900'}`} data-id="element-270" data-mp="2j02fwi8r4uq3">
            {title}
          </h3>
        </div>
        <p className={`mt-2 text-sm font-medium ${premium ? 'text-sky-100' : 'text-slate-500'}`} data-id="element-271" data-mp="2srq326y9zplr">
          {subtitle}
        </p>
      </div>

      <p className={`my-6 rounded-xl border p-4 text-sm leading-relaxed ${premium ? 'border-white/20 bg-white/10 text-sky-50' : 'border-sky-100 bg-sky-50/70 text-slate-600'}`} data-id="element-272" data-mp="2xo6rz3dau7zw">
        <b className={premium ? 'text-white' : 'text-slate-900'} data-id="element-273" data-mp="18bd04fc2ig5f">Ideal para:</b>{' '}
        {premium ? 'Profesionales y deportistas que quieren el sistema completo de rehabilitación MÁS el programa de 8 semanas para volver a entrenar con carga progresiva real después de la lesión.' : 'Profesores de educación física, entrenadores personales, kinesiólogos y personas con lesiones que quieren un sistema completo, progresivo y listo para aplicar en casa o en el gimnasio.'}
      </p>

      <ul className="mb-6 flex-1 space-y-2" data-id="element-274" data-mp="r2118vvnflms">
        {features.map(feature => <li key={feature} className={`flex items-start gap-2 text-sm font-medium ${premium ? 'text-white' : 'text-slate-700'}`} data-id="element-275" data-mp="1ns1kygh5vbx8">
            <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${premium ? 'text-amber-300' : 'text-accent'}`} data-id="element-276" data-mp="1itqbw7yox5g2" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6" data-id="element-277" data-mp="19rqsj907dp9y">
        <span className={`mb-3 inline-block rounded-full px-3 py-1 text-xs font-extrabold ${premium ? 'bg-gold text-white' : 'bg-sky-100 text-primary'}`} data-id="element-278" data-mp="19ulckzfb182u">
          AHORRÁS {savings}
        </span>
        <p className={`mt-2 text-sm font-bold line-through ${premium ? 'text-sky-200' : 'text-slate-400'}`} data-id="element-279" data-mp="1ma1nb08jsdx6">
          Antes: {before}
        </p>
        <p className={`mt-1 text-xs font-bold uppercase ${premium ? 'text-sky-100' : 'text-slate-500'}`} data-id="element-280" data-mp="1r2l03uzev50x">
          Hoy
        </p>
        <p className={`text-4xl font-extrabold ${premium ? 'text-white md:text-5xl' : 'text-slate-900'}`} data-id="element-281" data-mp="1h9x595rzrb4u">
          {price}
        </p>
      </div>

      <Button href={premium ? purchaseUrls.premium : purchaseUrls.base} fullWidth className={premium ? 'border-2 border-amber-100 bg-gold text-xs shadow-[0_0_0_5px_rgba(245,158,11,.28)] hover:bg-amber-600' : 'text-xs'} data-id="element-282" data-mp="29zdszq4o23uq">
        {premium ? 'QUIERO COMBO REHABILITACIÓN + PROGRAMA DE RETORNO' : 'QUIERO EL SISTEMA COMBO COMPLETO REHABILITACIÓN'}
      </Button>
    </article>;
}
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-283" data-mp="h175sljc87mq">
      <div className="text-center" data-id="element-284" data-mp="d1ok3njozsiu">
        <p className="text-[11px] font-bold uppercase tracking-[.16em] text-accent md:text-sm" data-id="element-285" data-mp="d0nalnibre38">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-286" data-mp="m137uf8h5ozn">
          Asegurá el precio promocional <span className="text-accent" data-id="element-287" data-mp="3uhoa7d6lpjts">antes de que suba.</span>
        </h2>
        <div className="mt-6" data-id="element-288" data-mp="3pjmsowotpskf">
          <Countdown data-id="element-289" data-mp="3pg8rvsvt5rf3" />
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-290" data-mp="82c0dbo4b1kh">
          {['Después sube $9.000 ARS', 'Esta promo no vuelve', '72% de los cupos ya tomados'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-600" data-id="element-291" data-mp="3bqnc0rdb1sba">
                <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-292" data-mp="1aph510rz9uuj" />
                {item}
              </span>)}
        </div>
      </div>

      <h2 className="mt-14 text-center text-3xl font-extrabold text-slate-900 md:text-5xl" data-id="element-293" data-mp="1flo5ie1lue53">
        Elegí tu <span className="text-accent" data-id="element-294" data-mp="1kguzuv8zi6hc">opción</span>
      </h2>
      <div className="mx-auto mt-10 grid max-w-5xl gap-8 md:grid-cols-2" data-id="element-295" data-mp="1oesr03mbf2nd">
        <PlanCard data-id="element-296" data-mp="rqd30byut1cd" />
        <PlanCard premium data-id="element-297" data-mp="rr4w9g4zamzh" />
      </div>
      <p className="mt-9 text-center text-xs font-medium text-slate-500" data-id="element-298" data-mp="rs683mttjdi9">
        Pago 100% seguro · Acceso en 5 minutos · Mercado Pago hasta 12 cuotas
      </p>
    </section>;
}